import { addTask } from '../../utilities/ssr-task';
import { API_FILTERS, API_FILTERS_OTHER_LANGUAGE } from '../actionTypes';
import APIManager from '../../utilities/api-manager';
import { get, getConfig, dateDiff } from '../../helpers';
import SPGVariables from '../../utilities/spg-variables';

const apiDataRefreshTime = getConfig('redux.cacheRefreshTimes.medium');
const spgVariables = SPGVariables();

const fetchOtherLanguageFilters = () => {
    return (dispatch: (action: FiltersResultAction) => void) => {
        const otherLanguages: string[] = spgVariables.SUPPORTED_LANGUAGES || [];

        const promises = otherLanguages.map((langCode: string) => {
            return APIManager.getBatchFiltersByKey(langCode)
                .then(response => {

                    dispatch({
                        response,
                        time: new Date(),
                        langCode,
                        type: API_FILTERS_OTHER_LANGUAGE
                    });

                    return { langCode, success: true };
                })
                .catch(error => {
                    return { langCode, success: false, error };
                });
        });
        Promise.all(promises);
    };
};

const fetchFilters = (): AppThunkAction<FiltersResultAction> => (dispatch, getState) => {
    const state = getState();
    const cachedResponse = get(state, 'filters');
    const hasExpired = cachedResponse && (!cachedResponse.time ? true : dateDiff(cachedResponse.time) > apiDataRefreshTime);
    if (hasExpired) {
        const fetchTask = APIManager.getBatchFilters().then(response => {
            dispatch({ response, time: new Date(), type: API_FILTERS });
        });
        addTask(fetchTask);
    }
};

export { fetchFilters, fetchOtherLanguageFilters };
